/**
 * 担当割当の履歴ビュー。変更ログ（AssignmentHistory）と担当カレンダー（OpsDutyCalendar）を TabGroup で
 * 切り替える。どちらも同じロスター変更履歴（events）を入力に取る。
 * @graph-stack product-innovation-lab
 * @graph-domain Operations
 * @graph-business 担当割当の履歴ビュー。変更ログと担当カレンダーを TabGroup で切り替える（同じ events を参照）
 * @graph-connects none
 */
import { useState, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { TabButton } from '../../ui/Tabs/TabButton.js';
import { TabGroup } from '../../ui/Tabs/TabGroup.js';
import { AssignmentHistory } from './AssignmentHistory.js';
import { OpsDutyCalendar } from './OpsDutyCalendar.js';
import type { OpsAssignmentEvent } from '../../../lib/api/ops.js';

/** OpsHistoryPanel の props。 @graph-connects none */
export interface OpsHistoryPanelProps {
  /** ロスター変更履歴（新しい順）。変更ログとカレンダーの両方が参照する。 */
  events: OpsAssignmentEvent[];
}

/** 変更ログ ⇄ 担当カレンダーを切り替える履歴ビュー。 @graph-connects none */
export function OpsHistoryPanel({ events }: OpsHistoryPanelProps): ReactNode {
  const { t } = useTranslation();
  const [historyView, setHistoryView] = useState<'changelog' | 'calendar'>('changelog');
  return (
    <div className="space-y-3">
      <TabGroup ariaLabel={t('ops.assignments.historyTabs.ariaLabel')}>
        <TabButton
          active={historyView === 'changelog'}
          label={t('ops.assignments.historyTabs.changelog')}
          onClick={() => {
            setHistoryView('changelog');
          }}
        />
        <TabButton
          active={historyView === 'calendar'}
          label={t('ops.assignments.historyTabs.calendar')}
          onClick={() => {
            setHistoryView('calendar');
          }}
        />
      </TabGroup>
      {historyView === 'changelog' ? (
        <AssignmentHistory events={events} />
      ) : (
        <OpsDutyCalendar events={events} />
      )}
    </div>
  );
}
